<template>
  <div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%;"
        v-loading="listLoading"
        size="default"
        border
    >
      <el-table-column property="projectName" label="项目名称"></el-table-column>
      <el-table-column v-if="serviceType == 6" property="amount" label="次数"></el-table-column>
      <el-table-column v-if="serviceType != 6 && projectType == 2" property="amount" label="张数"></el-table-column>
      <el-table-column v-if="serviceType != 6 && projectType != 2" property="price" label="金额"></el-table-column>
    </el-table>
    <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
import {getFormData} from "@/api/api";
import {getConsumeProjectShopPageList} from "@/api/url";

export default {
  name: "paymentNumDialog",
  props: {
    value: Object
  },
  data() {
    return {
      pageDataList: [],
      sumDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      consumeForm: this.value.consumeForm,
      serviceType: this.value.serviceType,
      projectType: this.value.projectType,

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['shopId'] = this.consumeForm.shopId;
      param['statDate'] = this.consumeForm.statDate;
      param['serviceType'] = this.serviceType;
      param['projectType'] = this.projectType;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getConsumeProjectShopPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },
  },
  mounted() {
    this.getPage()
  }
}
</script>

<style scoped>

</style>
